import { useEffect, useState } from "react";
import { Button, Card, Col, Row, Select, Typography, DatePicker, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import useWindowSize from "../../../Shared/Utils/windowResizeUtils";
import MenuItem from "antd/es/menu/MenuItem";
import "./MedicaidAgenda.scss";
import dayjs from "dayjs";
import { useFiltersHook } from "./CustomHooks";

const MedicaidAgenda = (props) => {
  const {startDate, endDate} = props;
  const { Title } = Typography;
  const { width } = useWindowSize();
  const isMobile = width <= 768;
  const [agendaData, setAgendadata] = useState({});
  const [selectedYears, setSelectedYears] = useState({});

   //----Custom Hook To Fetch Filters ---- //
    const fetchFilters = useFiltersHook();
    const { years    } = fetchFilters;

  useEffect(() => {
    if (props?.events?.length) {
      const grouped = groupEventsByDate(props.events);
      setAgendadata(grouped);
    } else {
      setAgendadata({});
    }
  }, [props?.events, props?.currentDate?.current]);

  /* ---------------- FORMAT TIME ---------------- */
  const formatToTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  /* ---------------- FORMAT DATE ---------------- */
  const dateAndDayFormatter = (date) => {
  const dateObject = new Date(date);

  const today = new Date();
  const tomorrow = new Date();
  const yesterday = new Date();

  today.setHours(0, 0, 0, 0);
  tomorrow.setHours(0, 0, 0, 0);
  yesterday.setHours(0, 0, 0, 0);
  dateObject.setHours(0, 0, 0, 0);

  tomorrow.setDate(today.getDate() + 1);
  yesterday.setDate(today.getDate() - 1);

  const monthYear = dateObject.toLocaleDateString([], {
    month: "long",
    year: "numeric",
  });

  const dayDate = dateObject.toLocaleDateString([], {
    weekday: "long",
    day: "numeric",
  });

  let label = "";

  if (dateObject.getTime() === today.getTime()) {
    label = " | Today";
  } else if (dateObject.getTime() === tomorrow.getTime()) {
    label = " | Tomorrow";
  } else if (dateObject.getTime() === yesterday.getTime()) {
    label = " | Yesterday";
  }

  return `${monthYear}, ${dayDate}${label}`;
};

  /* ---------------- GROUP EVENTS ---------------- */
  const groupEventsByDate = (events) => {
    const selectedMonth = new Date(props?.currentDate?.current).getMonth();
    const selectedYear = new Date(props?.currentDate?.current).getFullYear();

    const sortedEvents = [...events].sort(
      (a, b) => new Date(a.start) - new Date(b.start)
    );

    const grouped = sortedEvents.reduce((acc, event) => {
      const eventDate = new Date(event.start);

      // if (
      //   eventDate.getMonth() === selectedMonth &&
      //   eventDate.getFullYear() === selectedYear
      // ) {
      //   const localDateKey = eventDate.toLocaleDateString("en-CA"); 
      //   if (!acc[localDateKey]) {
      //     acc[localDateKey] = [];
      //   }

      //   acc[localDateKey].push(event);
      // }

      const localDateKey = eventDate.toLocaleDateString("en-CA"); 
        if (!acc[localDateKey]) {
          acc[localDateKey] = [];
        }

        acc[localDateKey].push(event);

      return acc;
    }, {});

    return grouped;
  };

  /* ---------------- EDIT ---------------- */
  const goToEdit = (meetingData) => {
    props.onCalenderSelect(meetingData);
  };

  const handleView = (view) => {
    props.updateView(view, props?.date);
  };

const handleDateChange = (date, type) => {
  // props.handleEvents({
  //   start: type === "start" ? date : startDate,
  //   end: type === "end" ? date : endDate,
  // });
};



const handleApply = () => {
  if (!startDate || !endDate) {
    message.error("Please select both start and end dates.");
    return;
  }

  if (!endDate.isAfter(startDate)) {
    message.error("End date must be greater than Start date.");
    return;
  }

  props.handleEvents({
    start: startDate,
    end: endDate,
  });

  message.success("Dates applied successfully!");
};

const handleYearChange = (e) => {
  props.handleEvents({
    years: e
  });
}



  return (
    <div className="agendaContainer">
      <div
        style={{
          display: "flex",
          // justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <Select
          onChange={handleView}
          value={props?.view}
          style={{ width: isMobile ? 60 : 120 }}
        >
          <MenuItem value="month">Month</MenuItem>
          <MenuItem value="agenda">Agenda</MenuItem>
        </Select>

        <Select
          placeholder="Select Year"
          mode="multiple"
          defaultValue={props?.year}
          options={years}
          style={{ width: 150, paddingLeft:'5px' }}
          onChange={handleYearChange}
        />
        {/* <div style={{ display: "flex", gap: "10px" }}>
          <DatePicker
            value={startDate || null}
            style={{ width: 300 }}
            name="start_date"
            placeholder="Select Start Date"
            onChange={(date) => handleDateChange(date, "start")}
          />
          <DatePicker
            value={endDate || null}
            name="end_date"
            style={{ width: 300, paddingLeft: "5px" }}
            placeholder="Select End Date"
            onChange={(date) => handleDateChange(date, "end")}
          />
        </div> */}
      </div>

      {Object.keys(agendaData)?.length > 0 ? (
        Object.keys(agendaData).map((agendaDate) => (
          <div key={agendaDate}>
            {/* DATE HEADER */}
            <div
              className="agendaDate"
              style={{
                color:
                  new Date().toDateString() ===
                  new Date(agendaDate).toDateString()
                    ? "#235D9F"
                    : undefined,
              }}
            >
              {dateAndDayFormatter(agendaDate)}
            </div>

            {/* EVENTS */}
            {agendaData[agendaDate].map((event) => (
              <Card
                key={event.id}
                style={{
                  margin: "10px 0",
                  borderLeft: `7px solid ${event?.backgroundColor}`,
                  borderTopLeftRadius: "4px",
                  borderBottomLeftRadius: "4px",
                  borderTopRightRadius: "0",
                  borderBottomRightRadius: "0",
                }}
              >
                <Row>
                  <Col span={12} style={{ alignSelf: "center" }}>
                    <div style={{ display: "flex" }}>
                      <div className="agendaText" style={{ minWidth: "8rem" }}>
                        {formatToTime(event?.start)} -{" "}
                        {formatToTime(event?.end)}
                      </div>

                      <div
                        className="agendaText"
                        style={{ marginLeft: "4rem" }}
                      >
                        {event?.title}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>
            ))}
          </div>
        ))
      ) : (
        <span className="noEvent">There are no events in this range.</span>
      )}
    </div>
  );
};

export default MedicaidAgenda;